import api from "@/lib/api";

// Kicks off a Stripe Checkout for a booking or registration and redirects.
// pay_in_full: members can opt to pay the whole amount instead of a deposit.
// couponCode: optional center coupon, validated & applied server-side.
export async function payFor(kind, refId, payInFull = false, couponCode = "", clientToken = "") {
  const origin_url = window.location.origin;
  const path = kind === "booking" ? `/checkout/booking/${refId}`
    : kind === "order" ? `/checkout/order/${refId}`
    : `/checkout/registration/${refId}`;
  const { data } = await api.post(path, { origin_url, pay_in_full: payInFull, coupon_code: couponCode || "", client_token: clientToken || "" });
  if (data.url) {
    window.location.href = data.url;
    return true;
  }
  return false;
}
